import { Component, Input } from '@angular/core';
import { SalvageTabContext } from '../salvage-tab-context';

@Component({
  selector: 'app-salvage-ongoing-tab',
  templateUrl: './salvage-ongoing-tab.component.html',
})
export class SalvageOngoingTabComponent {
  @Input() context!: SalvageTabContext;
}
